<template>
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12" vs-sm="12">
        <!--
            /////////////////
            Month view only
            /////////////////
        -->
        <vs-card>
            <h3 class="card-title d-flex">Input Anggaran</h3>
            <p class="card-subtitle"></p>
            <h3></h3>
            <vs-alert v-if="errors.length" class="mb-3 mt-2"  color="danger">
                <b>Terdapat Kesalahan..</b>
                <ul class="common-list">
                <li v-for="error in errors" :key="error">{{ error }}</li>
                </ul>
            </vs-alert>
            <vs-row>
            <vs-col vs-lg="7" vs-xs="12" vs-sm="4">  
                <vs-select autocomplete  class="w-100 mt-4" label="PERKIRAAN" ref="perkiraan" v-model="formdata.kode" 
                danger-text="Kode Perkiraan tidak sesuai"
                :danger="errorPerkiraan">
                <vs-select-item
                    :key="index"
                    :value="item.kode_perk"
                    :text="parseNama(item.nama)"
                    v-for="(item,index) in optperkiraan"
                />
                </vs-select>
            </vs-col>
            <vs-col vs-lg="1" vs-xs="12" vs-sm="4">  
               <div class="vs-component vs-con-input-label vs-input w-100 mt-4 vs-input-primary">  
                <label class="vs-input--label" >&nbsp;</label>
                <div class="vs-con-input"> 
                    <vs-switch v-model="tb" ref="tb">
                        <span slot="on">Tahunan</span>
                        <span slot="off">Bulanan</span>
                    </vs-switch>
                </div>
               </div>
            </vs-col>
            <vs-col vs-lg="3" vs-xs="12" vs-sm="3">  
                <vs-input label="NILAI ANGGARAN TAHUNAN" :disabled="is_bulanan" class="w-100 mt-4" ref="transval" v-model="formdata.anggaran_tahunan" v-currency="options"/>  
            </vs-col>
            </vs-row>
            <br/>
            <vs-divider>
                   ANGGARAN BULANAN
            </vs-divider>
            <vs-row>
                <vs-col vs-lg="12" vs-xs="12" vs-sm="4">  
                    <table width="100%" border="0" cellspacing="10" cellpadding="20">
                        <tr>
                            <td>Januari</td>
                            <td><vs-input class="w-50 p-1" :disabled="is_tahunan" ref="transval" v-model="formdata.bln_1" v-currency="options"/></td>
                            <td>Mei</td>
                            <td><vs-input class="w-50 p-1" :disabled="is_tahunan" ref="transval" v-model="formdata.bln_5" v-currency="options"/></td>
                            <td>September</td>
                            <td><vs-input class="w-50 p-1" :disabled="is_tahunan" ref="transval" v-model="formdata.bln_9" v-currency="options"/></td>
                        </tr>
                        <tr>
                            <td>Februari</td>
                            <td><vs-input class="w-50 p-1" :disabled="is_tahunan" ref="transval" v-model="formdata.bln_2" v-currency="options"/></td>
                            <td>Juni</td>
                            <td><vs-input class="w-50 p-1" :disabled="is_tahunan" ref="transval" v-model="formdata.bln_6" v-currency="options"/></td>
                            <td>Oktober</td>
                            <td><vs-input class="w-50 p-1" :disabled="is_tahunan" ref="transval" v-model="formdata.bln_10" v-currency="options"/></td>
                        </tr>
                        <tr>
                            <td>Maret</td>
                            <td><vs-input class="w-50 p-1" :disabled="is_tahunan" ref="transval" v-model="formdata.bln_3" v-currency="options"/></td>
                            <td>Juli</td>
                            <td><vs-input class="w-50 p-1" :disabled="is_tahunan" ref="transval" v-model="formdata.bln_7" v-currency="options"/></td>
                            <td>November</td>
                            <td><vs-input class="w-50 p-1" :disabled="is_tahunan" ref="transval" v-model="formdata.bln_11" v-currency="options"/></td>
                        </tr>
                        <tr>
                            <td>April</td>
                            <td><vs-input class="w-50 p-1" :disabled="is_tahunan" ref="transval" v-model="formdata.bln_4" v-currency="options"/></td>
                            <td>Agustus</td>
                            <td><vs-input class="w-50 p-1" :disabled="is_tahunan" ref="transval" v-model="formdata.bln_8" v-currency="options"/></td>
                            <td>Desember</td>
                            <td><vs-input class="w-50 p-1" :disabled="is_tahunan" ref="transval" v-model="formdata.bln_12" v-currency="options"/></td>
                        </tr>
                    </table>
                </vs-col>
          </vs-row>
            <div class="btn-alignment mt-4">
                <vs-button color="success" type="filled" @click.stop.prevent="checkForm">Simpan</vs-button>
                <vs-button color="dark" @click="backpage" type="filled">Batal</vs-button>
            </div>
        </vs-card>
        </vs-col>
        
    </vs-row>
    
</template>

<script>
/* eslint-disable no-unused-vars */

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { CurrencyDirective, parseCurrency, setValue } from 'vue-currency-input'

export default {
    components: {
        DatePicker
    },
    directives: {
        currency: CurrencyDirective
    },
    data:() => ({
        locale: 'us',
        formdata: {
           kode : '',
           tahun: window.$cookies.get('THN'),
           anggaran_tahunan:'',
           perkiraan: '',
           bln_1:'',
           bln_2:'',
           bln_3:'',
           bln_4:'',
           bln_5:'',
           bln_6:'',
           bln_7:'',
           bln_8:'',
           bln_9:'',
           bln_10:'',
           bln_11:'',
           bln_12:'',
           opr:'',
           isEdit: false,
           prevReferensi:''
        },
        tb:'tahunan',
        is_bulanan:false,
        is_tahunan:true,
        errors:[],
        errorPerkiraan:false,
        optperkiraan: [],
        optperkiraanKas: []
       
    }),
    methods: {
        backpage: function(){
            this.$router.push({name : 'anggaranlist'});
        },
        disabledBeforeYear(date) {
            return date.getFullYear() < window.$cookies.get('THN') || date.getFullYear() > window.$cookies.get('THN');
        },
        numberValue (value) {
            //alert(value)
            return parseCurrency(value.toString(), this.options)
        },
        getAllData: async function(){
            this.$http.get('/api/perkiraan').then(response => {
                //console.log(response.data);
                this.optperkiraan = response.data
                this.optperkiraanKas = this.optperkiraan.filter(function(kode){
                    return kode.kode_perk.substring(0,2) == '11'
                })
            }).catch(error=>{
                //console.log(error);
            });
            if(this.$route.params.ref != null){
                console.log('--edit--');
                this.formdata.isEdit = true
                let response = await this.$http.get('/api/anggaran/'+this.$route.params.ref);
                console.log(response.data)
                let values = [];
                for (let i = 1; i <= 12; i++) {
                    values.push(response.data[`bln_${i}`]);
                }
                let allSame = values.every(value => value === values[0]);

                if (allSame) {
                    console.log("All bln_1 to bln_12 values are the same.");
                } else {
                    this.tb = false
                }
                this.formdata.datatrans = response.data;
                const keys = Object.keys(response.data)
                
                for(const key of keys){
                    if (this.formdata.hasOwnProperty(key)){
                        if (key.startsWith('bln_') || key.startsWith('anggaran_')) {
                            // Format the value as a US number (e.g., with commas for thousands)
                            this.formdata[key] = new Intl.NumberFormat('en-US',{
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }).format(response.data[key]);
                        } else {
                            this.formdata[key] = response.data[key];
                        }
                    }
                    if(key == 'id')
                        this.formdata.prevReferensi = response.data[key]
                    
                }
                
            }
        },
        checkForm:function(e) {
            this.errors = [];
            //cek dari client dulu...
            if(this.formdata.kode == ''){
                this.errors.push("Kode Perkiraan belum terisi...")
            }

            if(this.formdata.anggaran_tahunan == ''){
                this.errors.push("Nilai anggaran belum terisi...")
            }

            if(this.errors.length > 0){
                this.handleError(this.error,'local')
            }
            else{
                this.$vs.loading({'type':'radius'})
                this.$http.post('/api/anggaran',{
                    formdata : this.formdata
                }).then(response => {
                    console.log(response);
                    this.handleSuccess();
                    //
                }).catch(error=>{
                    console.log(error.response)
                    this.handleError(error)
                })
            }
        },
        handleError: function(error,type=''){
            if(type != 'local'){
                if (error.code == 'ECONNABORTED'){
                    this.errors.push('Koneksi timeout, silahkan dicoba lagi diluar jam sibuk...')
                }
                else if (error.response != null){
                    let status = error.response.status
                    console.log(status)
                    switch(status){
                        case 422 :
                            const keys = Object.keys(error.response.data.errors)
                            //console.log(keys);
                            for(const key of keys){
                                //console.log(key)
                                //console.log(error.response.data.errors[key][0])
                                this.errors.push(error.response.data.errors[key][0])
                            }
                        break
                        case 500 :
                            this.errors.push('Internal server error.. silahkan hubungi administrator')
                            break
                        case 417 :
                            this.errors.push(error.response.data.error)
                            break    
                        default:
                            this.errors.push('Terjadi error di server..')
                            break
                    }
                }
                else
                    this.errors.push('Terjadi error di server..')
            }
            console.log('handle error')
            this.notify()
            this.$vs.loading.close()
        },
        handleSuccess: function(){
            this.$vs.loading.close()
            this.$vs.notify({title:'Success',text:'Data berhasil disimpan..',color:'success'})
            //this.$router.push('/jurnal/ju');
            this.$router.push({name : 'anggaranlist'});
        },
        notify: function(){
            this.$vs.notify({
                title:'Gagal Menyimpan Data',
                text:'Click untuk melihat',
                color:'danger',
                fixed:false,
                icon: 'warning',
                click:()=>{
                    window.scrollTo(0,0);
                },
            })
        },
        parseNama: function(nama){
            var parts = nama.split('+');
            return parts[0].replace(/=/g, ' ') + parts[1];        
        },
        trimObjValues: function(obj) {
            //console.log('trim')
            return _.reduce(obj,(acc, val, key) => {
                acc[key] = _.reduce(val, (acc1, val1, key1) => {
                    //console.log('--lodash yg obj--')
                    //console.log(key1)
                    //console.log(val1)
                    if(val1 != null)
                        acc1[key1] = val1.trim()
                    return acc1
                },{})
                //console.log('acc')
                //console.log(acc)
                return acc
            },[])
        }
    },
    computed: {
        options () {
            return {
                locale: this.locale,
                currency: this.currency
            }
        },
        anggaranBulanan() {
          let retval = ''
          for(let i=1;i<=12;i++){
              let index = "bln_"+i
                if (this.formdata.hasOwnProperty(index))
                    retval = retval + this.formdata[index] + '|'
          }
          //console.log(retval)
          return retval
        },
    },
    watch: {
        'tb': function(){
           //console.log(this.tb)
           if( this.tb){
                this.is_tahunan = true
                this.is_bulanan = false
            }
            else{
                this.is_tahunan = false
                this.is_bulanan = true
            }
        },
        'formdata.anggaran_tahunan': function() {
            if(this.tb){ //input tahunan
                let anggaran = this.numberValue(this.formdata.anggaran_tahunan)
                let perbulan = new Intl.NumberFormat('us-US',{notation: 'standard',minimumFractionDigits: 2,
                maximumFractionDigits: 2}).format(anggaran/12)
                for(let i=1;i<=12;i++){
                    let index = "bln_"+i
                    if (this.formdata.hasOwnProperty(index))
                        this.formdata[index] = perbulan
                }
            }
        },
        anggaranBulanan(newVal) {
          if(!this.tb){
            let arrVal = newVal.split('|')
            //console.log(arrVal.length)
            let jumlah = 0
            for(let i=0;i<12;i++){
                jumlah = jumlah + this.numberValue(arrVal[i])
            }
            this.formdata.anggaran_tahunan = new Intl.NumberFormat('us-US',{notation: 'standard',minimumFractionDigits: 2,
            maximumFractionDigits: 2}).format(jumlah)
          }
        },
    },
    mounted: function () {
        this.getAllData();
    },
}
</script>


<style>

</style>